import AboutPageCmsContainer from "../../container/admin/about-page-cms";

const AboutPageCms = () => {
    return <AboutPageCmsContainer />;
};

export default AboutPageCms;
